import { defineMessages } from 'react-intl'

const scope = 'app.containers.Organizations'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'All Organizations',
  },
  columns: {
    name: {
      id: `${scope}.columns.name`,
      defaultMessage: 'Organization Name',
    },
    alias: {
      id: `${scope}.columns.alias`,
      defaultMessage: 'Customer Alias',
    },
    domains: {
      id: `${scope}.columns.domains`,
      defaultMessage: 'Domains',
    },
    actions: {
      id: `${scope}.columns.actions`,
      defaultMessage: 'Actions',
    },
  },
})
